<div class="menu">
  <a class="menu-item-link notifications" (click)="openNotificationCenter()">
    <mat-list-item class="notification-item">
      <div>
        <mat-icon class="ic-svg-9" aria-hidden="false" aria-label="notifications_none">notifications_none</mat-icon>
      </div>
      <div class="notification-info">
        <span class="menu-name">{{ "message.notificationCentral.title" | translate }}</span>
        <div class="badge-notify" *ngIf="badgeActive"></div>
      </div>
    </mat-list-item>
  </a>
  <mat-list *ngFor="let item of menu">
    <app-layout-menu-item
      [icon]="item.configs.icon"
      [key]="item.key"
      [title]="item.configs.title | translate"
      [new]="item.configs.new | translate"
      [url]="item.configs.url"
      *ngIf="item.enabled && item.is_menu"
      (verify)="verifyMenu()"
    >
    </app-layout-menu-item>
  </mat-list>
</div>
